var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-filterSelect", class: _vm.computedClass },
    [
      _c(
        "div",
        { staticClass: "input-render" },
        [
          _c("label", { staticClass: "component-label" }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _c("div", {
            staticClass: "triangle-down z2",
            class: _vm.focused ? "up" : ""
          }),
          _c(
            "el-select",
            {
              staticClass: "component-filter-select w-normal",
              attrs: {
                placeholder: "请选择或输入学校全名",
                filterable: "",
                "filter-method": _vm.filterFun
              },
              on: {
                blur: _vm.handleSelectBlur,
                change: _vm.onSelectChange,
                "visible-change": function($event) {
                  return _vm.visibleChagneHandler($event)
                }
              },
              model: {
                value: _vm.selectInput,
                callback: function($$v) {
                  _vm.selectInput = $$v
                },
                expression: "selectInput"
              }
            },
            _vm._l(_vm.options, function(item, index) {
              return _c("el-option", {
                key: "option_" + index,
                staticClass: "w-normal",
                class: _vm.getOptionClass(item),
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      ),
      (_vm.startVerific && _vm.error) || _vm.error
        ? _c("div", { staticClass: "errmsg" }, [_vm._v(_vm._s(_vm.errmsg))])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }